import { AdjacentType } from '@iotv/iotv-v3-types';
import { getAdjacent } from '../../../../data/Wideawake/wideawakeDataFns';
export const getGatewayDevices = async ({ sourceNode, ExclusiveStartKey, Limit, }) => {
    const edgeParams = {
        edgeTypeId: undefined,
        objectTypeId: 'Device',
        adjacencyType: AdjacentType.CHILD,
    };
    const res = await getAdjacent({ sourceNode, edgeParams, ExclusiveStartKey, Limit });
    if (res.err === null && res.data) {
        const { Items } = res.data;
        const { skMapped } = Items;
        // the correct way to do this is to construct a NodeEdgeMapper and use its methods. Not looking at this now.
        const found = [];
        Object.keys(skMapped).forEach((pairing) => {
            const device = skMapped[pairing][pairing];
            if (device && device.type === 'Device') {
                found.push(device);
            }
        });
        return found;
    }
    else {
        return [];
    }
};
